import React from "react";
import { TopToolbar, ShowProps, TabbedShowLayout, Tab } from "react-admin";
import { Grid } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import { UserResources } from "utils/tools";
import Summary from "./Summary";
import ActivateUserButton from "./components/ActivateUserButton";
import InactiveUserButton from "./components/InactiveUserButton";
import ShowWrapper from "../../components/ShowWrapper";

const UserShow = (props: ShowProps) => {
  const { id } = props;

  const breadcrumb = [
    {
      title: "Users",
      link: `/users`,
    },
    {
      title: id,
      link: "",
    },
  ];

  const UserShowAction = (props: any) => {
    const UserResource = UserResources(Number(id));

    return (
      <TopToolbar>
        {UserResource?.admin.status !== "active" ? (
          <ActivateUserButton userId={id} {...props} />
        ) : (
          <InactiveUserButton userId={id} {...props} />
        )}
      </TopToolbar>
    );
  };

  return (
    <>
      <ShowWrapper
        breadcrumb={breadcrumb}
        customFieldName="email"
        actions={<UserShowAction />}
        {...props}
      >
        <SanitizedGrid container spacing={2}>
          <Grid item xs={12}>
            <TabbedShowLayout>
              <Tab label="Summary">
                <Summary {...props} />
              </Tab>
            </TabbedShowLayout>
          </Grid>
        </SanitizedGrid>
      </ShowWrapper>
    </>
  );
};

export default UserShow;
